import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const VARIANTS = {
  success: {
    bg: 'bg-success/15',
    border: 'border-success/40',
    icon: 'CheckCircle',
    iconColor: 'var(--color-success)',
  },
  error: {
    bg: 'bg-error/15',
    border: 'border-error/40',
    icon: 'AlertTriangle',
    iconColor: 'var(--color-error)',
  },
  info: {
    bg: 'bg-primary/12',
    border: 'border-primary/30',
    icon: 'Info',
    iconColor: 'var(--color-primary)',
  },
};

const SaveToast = ({ message, subtitle, variant = 'success', visible = false, onClose, duration = 2500, offsetTop = 88, offsetRight = 24 }) => {
  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => onClose?.(), duration);
    return () => clearTimeout(t);
  }, [visible, duration, onClose]);

  const styles = VARIANTS[variant] || VARIANTS.info;
  const defaultSubtitle =
    subtitle ?? (variant === 'success'
      ? 'Saved securely to your account'
      : variant === 'error'
        ? 'Something unexpected occurred. Please try again.'
        : 'Notification');

  return (
    <div
      className={`fixed z-50 transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'
      }`}
      style={{ top: offsetTop, right: offsetRight }}
    >
      <div className={`rounded-xl border ${styles.border} ${styles.bg} shadow-lg backdrop-blur-sm min-w-[280px] p-4 flex items-start gap-3`}>
        <div className="flex-shrink-0">
          <div className="w-8 h-8 rounded-lg bg-background/50 flex items-center justify-center">
            <Icon name={styles.icon} size={18} color={styles.iconColor} />
          </div>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-foreground">{message}</p>
          <p className="text-xs text-muted-foreground mt-1">{defaultSubtitle}</p>
        </div>
        <button
          aria-label="Close"
          className="text-muted-foreground hover:text-foreground transition-colors"
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default SaveToast;
